import ResultsTimelineChart from '../globals/ResultsTimelineChart'

export default {
  extends: ResultsTimelineChart,
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                display: true
              },
              gridLines: {
                display: true,
                drawBorder: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                display: true
              },
              gridLines: {
                display: true,
                drawBorder: true
              }
            }
          ]
        }
      }
    }
  }
}
